<template id="div-vid">
<!-- HASTA AQUI FUNCIONABA PUSE EL DUV CONTENEDOR TAMBIEN EN EL RENDER -->

    <div class="width-section">
      <div class="trailer-back-sm" ref="back_video_sm" :style="{display:visibilityCloseSm}">
          <b-icon icon="x" @click="close_sm" ref="iconClose" :style="{ display: visibilityCloseSm }" class="close-sm"></b-icon>
      </div>
      <div class="title-video-sm">
      <p class="text-video-service-sm" v-bind:text="textVideo">{{textVideo}}</p>
      </div>
      <!-- <b-icon icon="x" @click="close_sm" :style="{ display: visibilityCloseSm }" class="close-sm" variant="light" font-scale="3"></b-icon> -->
      <!-- ESTO ES LO DEL VIDEO DE ANTES -->
      <!-- <div class="text-center embed-responsive-16by9" :class="[enbebedSm,minVideoSm,fullVideoSm]">
      <video ref="video_ref" muted="muted" :class="videoServiceSm" v-bind:poster="poster">
          <source v-bind:src="src">
      </video>
      </div> -->
      <div class="text-center" :class="[minVideoSm,fullVideoSm]">
        <img ref="video-img" :class="[marg , imgTam]" :src="poster" alt="servicio">
      </div>
      <button class="btn-project-sm" v-on:click="setProject(claseId)" ref="btn_proj">{{ $t('services.lookProject') }}</button>
      <!-- <b-button variant="outline-secondary" class="btn-project-sm">{{ $t('services.lookProject') }}</b-button> -->
      <div class="button-video-service-sm" @click="start_sm" ref="btn_play">
      <b-icon icon="play"></b-icon>
      </div>
    </div>
</template>

<script>
export default {
  data(){
    return {
      fullVideoSm:"",
      minVideoSm:"div-video-service-sm",
      enbebedSm:"embed-responsive",
      videoServiceSm:"video-service-sm",
      visibilityCloseSm: "none",
      animateSm: "animate__animated",
      fadeRightSm:"animate__fadeInRight",
      slowSm:"animate__slow 0.5s",
      marg:"marg",
      imgTam:"img-resp"
      // videoCurrent:"",
    }
  },
  methods:{
    setProject: function(clase){
      
      console.log("moverse de panel");

      var clas;
      let imgs = document.querySelectorAll(".proyecto");
      this.show="none";
      this.animation="";
      this.animateDirection="";
      let row = document.querySelectorAll("#row-content");
      row.style="display:none";

      if(this.posicion>clase){
        
        this.animation="animate__animated";
        this.animateDirection= "animate__fadeInLeft";
      }
      if(this.posicion<clase){

        this.animation="animate__animated";
        this.animateDirection="animate__fadeInRight";
      }

      if(clase===7){
        clas="brand";
        this.posicion=1;
      }
      if(clase===8){
        clas="motion"
        this.posicion=2;
      }
      
      if(clase===10){
        clas="managment";
        this.posicion=4;
      }
      if(clase===11){
        clas="design-serv"
        this.posicion=5;
      }
      if(clase===13){
        clas="interface"
        this.posicion=6;
      }
      console.log("la clase: "+clase+"la position"+this.posicion);
      if(clase===9 || clase===12){
        this.posicion=0;
        for (const img of imgs) {
          img.style="display: block";
          row.style="display:block";
        }
      }
      else{
        for (const img of imgs) {
          img.style="display: none";
        }
        let img_brand= document.querySelectorAll("."+clas);

        if(img_brand.length===0){

          this.show="block";
          row.style="display:block";
        }
        for (const img of img_brand) {
          img.style="display:block";
          row.style="display:block";
        }
      
      }

      let linked="#nav"+this.posicion;
      console.log("vamos al proyecto num: "+linked);
      location.href=linked;
      const links = document.querySelectorAll(".mynav a");
      const target = document.querySelector(".target");

      let element=document.querySelector("#nav"+this.posicion);

      for (let i = 0; i < links.length; i++) {
        if (links[i].classList.contains("active")) {
          links[i].classList.remove("active");
          links[i].classList.remove("active-col");
        }
        links[i].style.opacity = "1";
      }

      element.classList.add("active");
      element.classList.add("active-col");
      element.style.opacity = "1";

      const width = (element.getBoundingClientRect().width-58);
      const left = (element.getBoundingClientRect().left + window.pageXOffset+27);
      const top = element.getBoundingClientRect().top + window.pageYOffset;

      target.style.width = `${width}px`;
      target.style.left = `${left}px`;
      target.style.transition="all .4s ease-in-out";
      target.style.top=`${top}px`;

    },
    start_sm(){
      let scll = document.querySelector("body");
      this.minVideoSm="";
      this.enbebedSm="";
      this.videoServiceSm="video-service-sml";
      this.fullVideoSm="trailer-video-sm";
      this.visibilityCloseSm = "flex";

      var videoCurrent=document.getElementsByClassName('div-svideo-sm');
      for (const current of videoCurrent) {
        console.log(current);
        current.classList.remove('animate__animated');
        current.classList.remove('animate__fadeInRight');
      }

      
      this.animateSm="";
      this.fadeRightSm="";
      this.slowSm="";
      scll.setAttribute("style", "overflow-y: hidden");
      
    },
    close_sm() {

      let scll = document.querySelector("body"); 
      this.minVideoSm="div-video-service-sm";
      this.enbebedSm="embed-responsive";
      this.videoServiceSm="video-service-sm";
      this.fullVideoSm="";

      var videoCurrent=document.getElementsByClassName('div-svideo-sm');
      for (const current of videoCurrent) {
        console.log(current);
        current.classList.add('animate__animated');
        current.classList.add('animate__fadeInRight');
      }
    
      this.visibilityCloseSm = "none";
      scll.setAttribute("style", "overflow-y: visible");
    },
    start_smV(){
      let scll = document.querySelector("body");
      this.minVideoSm="";
      this.enbebedSm="";
      this.videoServiceSm="video-service-sml";
      this.fullVideoSm="trailer-video-sm";
      this.visibilityCloseSm = "flex";

      var videoCurrent=document.getElementsByClassName('div-svideo-sm');
      for (const current of videoCurrent) {
        console.log(current);
        current.classList.remove('animate__animated');
        current.classList.remove('animate__fadeInRight');
        // current.classList.remove('animate__slow 0.5s');
      }

      var vid = this.$refs.video_ref;
      this.animateSm="";
      this.fadeRightSm="";
      this.slowSm="";
      vid.muted=false;
      vid.play();
      // var bt1=this.$refs.btn_proj;
      // var bt2=this.$refs.btn_play;

      // bt1.style="display:none";
      // bt2.style="display:none";

      scll.setAttribute("style", "overflow-y: hidden");
      
    },
    close_smV() {

      let scll = document.querySelector("body"); 
      var vid = this.$refs.video_ref;
      this.minVideoSm="div-video-service-sm";
      this.enbebedSm="embed-responsive";
      this.videoServiceSm="video-service-sm";
      this.fullVideoSm="";
      // var bt1=this.$refs.btn_proj;
      // var bt2=this.$refs.btn_play;

      var videoCurrent=document.getElementsByClassName('div-svideo-sm');
      for (const current of videoCurrent) {
        console.log(current);
        // current.style="display:none";
        current.classList.add('animate__animated');
        current.classList.add('animate__fadeInRight');
        // current.style="display:flex";
        // current.classList.remove('animate__slow 0.5s');
      }
    
      this.visibilityCloseSm = "none";
      vid.muted=true;
      scll.setAttribute("style", "overflow-y: visible");
    }
  },
  template:"#div-vid",
  props:{
    'src':{
      type:String
    },
    'video_ref':{
      type:String
    },
    'poster':{
      type:String
    },
    'textVideo':{
      type:String
    },
    'claseId':{
      type:Number
    },
    'active':{
      type:Number
    }
  }
  
};
</script>

<style>

.close-sm{
  position: absolute;
  top:25%;
  right: 2%;
  font-size: 50px;
  color:#ffffff;
  cursor: pointer;
  z-index: 5;
}

.close-tar{
  position: relative;
  left: 80%;
  margin-top: 20px;
}

.trailer-video-sm{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  background: #000000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.trailer-back-sm{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  /* background: rgba(0, 0, 0, .95); */
  background: transparent;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-left: -7.5%; */
}

</style>